import React, { useState } from "react";
import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";


const Dashboard = () => {
 return (
   <div>
     <SideMenu />
     <div className="dashboard">
       <h1>DashBoard</h1>
     </div>
   </div>
 )
};

export default Dashboard;